import * as React from 'react';

export const TwitterSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={51}
      height={50}
      fill='none'
    >
      <path
        fill='#55ACEE'
        d='M.5 0h50v50H.5z'
      />
      <g>
        <path
          fill='#fff'
          d='M35.105 18.523a7.797 7.797 0 0 1-.995.362c.402-.455.709-.99.896-1.575a.332.332 0 0 0-.486-.386 7.83 7.83 0 0 1-2.314.915 4.438 4.438 0 0 0-3.091-1.26 4.421 4.421 0 0 0-4.38 4.986 11.306 11.306 0 0 1-7.76-4.116.331.331 0 0 0-.544.042 4.414 4.414 0 0 0-.598 2.22c0 1.065.38 2.074 1.051 2.863a3.746 3.746 0 0 1-.591-.264.332.332 0 0 0-.493.283v.059c0 1.588.854 3.018 2.161 3.797a3.838 3.838 0 0 1-.335-.048.332.332 0 0 0-.379.427 4.414 4.414 0 0 0 3.235 2.96 7.812 7.812 0 0 1-4.176 1.192c-.313 0-.627-.019-.935-.055a.332.332 0 0 0-.218.609 11.91 11.91 0 0 0 6.44 1.887c4.496 0 7.308-2.12 8.876-3.899 1.955-2.217 3.076-5.153 3.076-8.053 0-.122-.002-.244-.005-.366a8.586 8.586 0 0 0 1.976-2.093.332.332 0 0 0-.41-.487Z'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path
            fill='#fff'
            d='M15 16h20.572v18H15z'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
